import React, { Fragment } from "react";
import "./assets/css/style.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Projects from "./components/Projects";

const App = () => {
  return (
    <Fragment>
      <Home />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </Fragment>
  );
};

export default App;
